import { Box, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useAsync } from 'react-async-hook';
import { Link, match } from 'react-router-dom';
import { httpGet, modelQueryUrl } from '../../api/http';
import { SkuLocation, WarehouseLocation } from '../../api/models';
import { setApplicationTitle } from '../../providers/app';
import Preloader from '../../shared/Preloader';
import RemoteItems from '../../shared/RemoteItems';
import { SummaryList, SummaryListItem } from '../../shared/SummaryList';
import { SwitchBottomNavigation, SwitchBottomNavigationCase } from '../../shared/SwitchBottomNavigation';

const WarehouseLocationDetailPage: React.FC<{ match: match<any> }> = ({ match }) => {
	const { result: warehouseLocation, error } = useAsync(() => httpGet<WarehouseLocation>(`/warehouses/locations/${match.params.id}`), []);

	useEffect(() => {
		setApplicationTitle(`Lokace ${warehouseLocation?.name || ''}`);
	}, [warehouseLocation]);

	return (
		<Preloader loading={warehouseLocation == null} error={error} content={() => (
			<SwitchBottomNavigation>
				<SwitchBottomNavigationCase label="Detail" icon="assignment">
					<Box p={1}>
						<SummaryList>
							<SummaryListItem label="Lokace">{warehouseLocation.name}</SummaryListItem>
							<SummaryListItem label="Kód">{warehouseLocation.code}</SummaryListItem>
						</SummaryList>
					</Box>
				</SwitchBottomNavigationCase>

				<SwitchBottomNavigationCase label="Seznam SKU" icon="list">
					<Table>
						<TableHead>
							<TableRow>
								<TableCell>SKU</TableCell>
								<TableCell>Počet</TableCell>
								<TableCell>Paleta</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							<RemoteItems
								endpoint={modelQueryUrl<SkuLocation>('/skus/locations', {
									warehouseLocation: {
										id: { equals: warehouseLocation.id }
									}
								})}
								each={(item: SkuLocation) => (
									<TableRow key={item.id}>
										<TableCell>
											<Link to={`/skus/${item.sku.id}`}>{item.sku.masterCode}</Link>
										</TableCell>
										<TableCell>{item.quantity}</TableCell>
										<TableCell>
											<Link to={`/palettes/${item.palette.id}`}>{item.palette?.number}</Link>
										</TableCell>
									</TableRow>
								)} />
						</TableBody>
					</Table>
				</SwitchBottomNavigationCase>
			</SwitchBottomNavigation >
		)}>
		</Preloader >
	);
}

export default WarehouseLocationDetailPage;
